import { SyntheticEvent, useCallback, useEffect, useState } from "react";
import { readDataStorage } from "../../utils/storage/storage";
import { Data } from "../TableFilter/Tables/Table";
import { Container } from "./styles";
import { Autocomplete, TextField } from "@mui/material";

export function AnaliseProposta() {
  const [data, setData] = useState<Data[]>([]);
  const [selectedOption, setSelectedOption] = useState({
    label: "Todos",
    value: "Todos",
  });
  const [somaMensalidade, setSomaMensalidade] = useState<string>("");
  const [list, setList] = useState<string[]>([]);

  const setSoma = (status: string = "Todos") => {
    const registrosFiltrados =
      status === "Todos"
        ? data
        : data.filter((registro) => registro.status_arp === status);

    const somaTotal = registrosFiltrados.reduce((acumulador, registro) => {
      const mensalidade = parseFloat(registro.mensalidade_axs) || 0;
      return acumulador + mensalidade;
    }, 0);

    setSomaMensalidade(
      somaTotal.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
      })
    );
  };

  const handleChangeSoma = (
    _: SyntheticEvent,
    value: { label: string; value: string } | null
  ) => {
    setSelectedOption(value || { label: "Todos", value: "Todos" });
    setSoma(value?.value);
  };

  const fetchData = useCallback(async () => {
    const { Cards } = readDataStorage("dados");
    setData(Cards);

    let modifiedData = Cards.map(function (option: any, i: any) {
      if (option.status_arp) {
        return option.status_arp;
      }
      if (!option.status_arp) {
        return " ";
      }
      return option.status_arp;
    });

    const filtered = modifiedData.filter(
      (item: any, index: any) => modifiedData.indexOf(item) === index
    );
    const filteredOrder = filtered.sort();
    setList(filteredOrder);
  }, []);

  useEffect(() => {
    setSoma("Todos");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  useEffect(() => {
    fetchData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <Autocomplete
        value={selectedOption}
        sx={{ width: "23rem" }}
        defaultValue={{ label: "Todos", value: "Todos" }}
        onChange={handleChangeSoma}
        options={[
          { label: "Todos", value: "Todos" },
          ...list.map((item) => ({ label: item, value: item })),
        ]}
        renderInput={(params) => (
          <TextField {...params} label="Status" variant="outlined" />
        )}
      />
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <h1>Somatório por status: </h1>
        <h1>{somaMensalidade}</h1>
      </div>
    </Container>
  );
}
